import { Pipe, Injectable, PipeTransform } from '@angular/core';

@Pipe({
  name: 'NetworkType'
})

@Injectable()
export class NetworkTypePipe implements PipeTransform {
  transform(items: any[], type: number): any {
    if (!items) { return null; }
    if (!type) { return items; }
    return items.filter(item => item.BenefitTypeId === type);
  }
}
